import { Link } from 'react-router-dom';
import type { components } from '@bookingdei/api-client/types';
import { HxListingCard } from './hx-listing-card';
import { Ic } from './hx-icon';
import type { HomeFormat } from './use-home-format';

type BusinessSummary = components['schemas']['BusinessSummary'];

// A titled run of listing cards — a sideways rail ("New to …") or a grid ("Things to do
// this weekend."), as the design lays each out. `items` undefined means still loading: the
// band is not drawn until its data arrives, and not at all when it has none.
export function HxCards({
  title,
  sub,
  seeAll,
  to,
  items,
  layout,
  footnote,
  fmt,
}: {
  title: string;
  sub: string;
  seeAll: string;
  to: string;
  items: BusinessSummary[] | undefined;
  layout: 'rail' | 'grid';
  footnote?: string | undefined;
  fmt: HomeFormat;
}) {
  if (!items || items.length === 0) return null;
  return (
    <section className="sec">
      <div className="in">
        <div className="sh rv">
          <div>
            <h2>{title}</h2>
            <p>{sub}</p>
          </div>
          <Link className="more" to={to}>
            {seeAll} <Ic id="arrow" />
          </Link>
        </div>
        <div className={layout === 'rail' ? 'hs cards' : 'g4'}>
          {items.map((b) => (
            <HxListingCard key={b.id} business={b} fmt={fmt} />
          ))}
        </div>
        {footnote ? <p className="foot rv">{footnote}</p> : null}
      </div>
    </section>
  );
}
